/*
 * Copyright (C) 2021 Nile Camai.  All rights reserved.
 * I don't really care if you use this, even though it took me a hot second to figure
 * out what I was doing here, ultimately
 * I have better things to do than get upset that someone is taking my GeoTransform.ts
 */

/**
 * GeoTransform is a utility class for the UW Campus Paths application
 * that transforms geographic coordinates to pixel units used in the
 * campus map.
 */
export default class GeoTransform {

    /**
     * The map image's dimensions.
     */
    static CANVAS_WIDTH: number = 4330;
    static CANVAS_HEIGHT: number = 2964;

    /**
     * The Northwest corner of the image, translated to geographic coordinates
     */
    static NORTHWEST_CORNER: {latitude: number, longitude: number} = {
        latitude: 47.663246838874194,
        longitude: -122.32419790015427,
    };

    /**
     * The Southeast corner of the image, translated to geographic coordinates
     */
    static SOUTHEAST_CORNER: {latitude: number, longitude: number} = {
        latitude: 47.64653174086308,
        longitude: -122.2883097296453,
    };

    /**
     * Converts a longitudinal geographic coordinate to its pixel y-coordinate counterpart.
     *
     * @param canvasWidth the width of the campus image, defaulted to the class constant
     * @param xGeo the geographic x-coordinate in longitude
     */
    static longitudeToPixelCoordinate(xGeo: number, canvasWidth: number = this.CANVAS_WIDTH): number {
        const xRange: number = this.SOUTHEAST_CORNER.longitude - this.NORTHWEST_CORNER.longitude;
        const geoPerPixel: number = xRange / canvasWidth;
        return (xGeo - this.NORTHWEST_CORNER.longitude) / geoPerPixel;
    }

    /**
     * Converts a latitudinal geographic coordinate to its pixel x-coordinate counterpart.
     *
     * @param canvasHeight the height of the campus image, defaulted to the class constant
     * @param yGeo the geographic y-coordinate in latitude
     */
    static latitudeToPixelCoordinate(yGeo: number, canvasHeight: number = this.CANVAS_HEIGHT) {
        const yRange: number = this.NORTHWEST_CORNER.latitude - this.SOUTHEAST_CORNER.latitude;
        const geoPerPixel: number = yRange / canvasHeight;
        return (this.NORTHWEST_CORNER.latitude - yGeo) / geoPerPixel;
    }
}